import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm$meterNameArr, _vm$meterNameArr2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "viewRef"
  }, [_c('div', {
    staticClass: "instant_chart_wrap d-flex"
  }, [_vm._l(_vm.demandData, function (d) {
    var _d$value;
    return _c('div', {
      key: d.title,
      staticClass: "instant_card"
    }, [_c('div', {
      staticClass: "instant_card_title"
    }, [_c('div', [_vm._v(_vm._s(d.title))]), d.breakTitle ? _c('div', [_vm._v(_vm._s(d.breakTitle))]) : _vm._e()]), _c('div', {
      staticClass: "instant_card_value"
    }, [_c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('span', {
      key: _vm.lastUpdateTime
    }, [_vm._v(_vm._s((_d$value = d.value) !== null && _d$value !== void 0 ? _d$value : "-"))])])], 1), _c('span', {
      staticClass: "instant_card_unit"
    }, [_vm._v(_vm._s(d.unit))]), _c('div', {
      staticClass: "instant_icon"
    })]);
  }), _c('div', {
    staticClass: "chart_pie_wrap"
  }, [_c('div', {
    staticClass: "content_title mt-10"
  }, [_vm._v("本月用電佔比")]), _c('highcharts', {
    staticClass: "mt-4",
    attrs: {
      "id": "pieChartId",
      "options": _vm.pieChartOptions
    }
  })], 1)], 2), _c('div', {
    staticClass: "meter_chart_wrap d-flex mt-5"
  }, [_c('div', {
    staticClass: "swiper_wrap position-relative",
    style: {
      width: _vm.swiperWrapWidth
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm$meterNameArr = _vm.meterNameArr) === null || _vm$meterNameArr === void 0 ? void 0 : _vm$meterNameArr.length) > _vm.SHOW_SWIPER_COUNT,
      expression: "meterNameArr?.length > SHOW_SWIPER_COUNT"
    }],
    staticClass: "btn_openModal position-absolute",
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_vm._v(" mdi-arrow-top-right ")]), _c('v-dialog', {
    staticClass: "meter_dialog",
    attrs: {
      "max-width": "1378",
      "scrollable": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column meter_dialog_card"
  }, [_c('div', {
    staticClass: "modal_title_wrap d-flex"
  }, [_c('div', {
    staticClass: "modal_title"
  }, [_vm._v("電表資訊")]), _c('v-btn', {
    staticClass: "ml-auto",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider', {
    staticClass: "my-0"
  }), _c('v-autocomplete', {
    staticClass: "textInput ml-auto px-6 pt-4",
    attrs: {
      "items": _vm.meterLocationArr,
      "outlined": "",
      "attach": "",
      "dense": "",
      "small-chips": "",
      "hide-details": "",
      "deletable-chips": "",
      "color": "energy_blue",
      "item-color": "energy_blue",
      "clearable": "",
      "multiple": "",
      "label": "電表位置",
      "placeholder": "選擇電表位置"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item,
          index = _ref.index;
        return [index < 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": "",
            "close": ""
          },
          on: {
            "click:close": function clickClose($event) {
              return _vm.removeSelectedMeterLocation(item);
            }
          }
        }, [_vm._v(" " + _vm._s(item) + " ")]) : _vm._e(), index === 2 ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c('v-chip', _vm._g(_vm._b({
                staticClass: "ma-1",
                attrs: {
                  "small": ""
                }
              }, 'v-chip', attrs, false), on), [_vm._v(" +" + _vm._s(_vm.selectedMeterLocation.length - 2) + " ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v(" " + _vm._s(_vm.selectedMeterLocation.slice(2).join("、")) + " ")])]) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.selectedMeterLocation,
      callback: function callback($$v) {
        _vm.selectedMeterLocation = $$v;
      },
      expression: "selectedMeterLocation"
    }
  }), _c('div', {
    staticClass: "modal_content d-flex flex-wrap overflow-y-auto"
  }, _vm._l(_vm.filteredMeterLocationArr, function (location, lIdx) {
    var _vm$meterData$lIdx, _vm$meterData$lIdx$P, _vm$meterData$lIdx2, _vm$meterData$lIdx$in, _vm$meterData$lIdx3, _vm$meterData$lIdx$ma, _vm$meterData$lIdx4, _vm$meterData$lIdx$kW, _vm$meterData$lIdx5;
    return _c('div', {
      key: (_vm$meterData$lIdx = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx === void 0 ? void 0 : _vm$meterData$lIdx.meterId,
      staticClass: "modal_meter_card"
    }, [_c('div', {
      staticClass: "meter_card_position"
    }, [_vm._v(_vm._s(location))]), _c('div', {
      staticClass: "meter_card_demand"
    }, [_vm._v("即時功率")]), _c('div', {
      staticClass: "d-flex align-items-baseline"
    }, [_c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('div', {
      key: _vm.lastUpdateTime,
      staticClass: "meter_card_value"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$P = (_vm$meterData$lIdx2 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx2 === void 0 ? void 0 : _vm$meterData$lIdx2.P) !== null && _vm$meterData$lIdx$P !== void 0 ? _vm$meterData$lIdx$P : "-") + " ")])]), _c('div', {
      staticClass: "meter_card_unit"
    }, [_vm._v("kW")])], 1), _c('div', {
      staticClass: "meter_card_divider"
    }), _c('div', {
      staticClass: "d-flex my-1"
    }, [_c('span', [_vm._v("即時需量")]), _c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('span', {
      key: _vm.lastUpdateTime,
      staticClass: "ml-auto"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$in = (_vm$meterData$lIdx3 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx3 === void 0 ? void 0 : _vm$meterData$lIdx3.instant_demand) !== null && _vm$meterData$lIdx$in !== void 0 ? _vm$meterData$lIdx$in : "-") + " ")])]), _c('span', [_vm._v(" 瓩")])], 1), _c('div', {
      staticClass: "d-flex my-1"
    }, [_c('span', [_vm._v("最大需量")]), _c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('span', {
      key: _vm.lastUpdateTime,
      staticClass: "ml-auto"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$ma = (_vm$meterData$lIdx4 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx4 === void 0 ? void 0 : _vm$meterData$lIdx4.max_demand) !== null && _vm$meterData$lIdx$ma !== void 0 ? _vm$meterData$lIdx$ma : "-") + " ")])]), _c('span', [_vm._v(" 瓩")])], 1), _c('div', {
      staticClass: "d-flex my-1"
    }, [_c('span', [_vm._v("累積用電")]), _c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('span', {
      key: _vm.lastUpdateTime,
      staticClass: "ml-auto"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$kW = (_vm$meterData$lIdx5 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx5 === void 0 ? void 0 : _vm$meterData$lIdx5.kWh) !== null && _vm$meterData$lIdx$kW !== void 0 ? _vm$meterData$lIdx$kW : "-") + " ")])]), _c('span', [_vm._v(" 度")])], 1)]);
  }), 0)], 1)], 1), _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l(_vm.meterLocationArr, function (location, lIdx) {
    var _vm$meterData$lIdx6, _vm$meterData$lIdx$P2, _vm$meterData$lIdx7, _vm$meterData$lIdx$in2, _vm$meterData$lIdx8, _vm$meterData$lIdx$ma2, _vm$meterData$lIdx9, _vm$meterData$lIdx$kW2, _vm$meterData$lIdx10;
    return _c('swiper-slide', {
      key: (_vm$meterData$lIdx6 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx6 === void 0 ? void 0 : _vm$meterData$lIdx6.meterId,
      staticClass: "meter_card"
    }, [_c('div', {
      staticClass: "meter_card_position"
    }, [_vm._v(_vm._s(location))]), _c('div', {
      staticClass: "meter_card_demand"
    }, [_vm._v("即時功率")]), _c('div', {
      staticClass: "d-flex align-items-baseline"
    }, [_c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('div', {
      key: _vm.lastUpdateTime,
      staticClass: "meter_card_value"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$P2 = (_vm$meterData$lIdx7 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx7 === void 0 ? void 0 : _vm$meterData$lIdx7.P) !== null && _vm$meterData$lIdx$P2 !== void 0 ? _vm$meterData$lIdx$P2 : "-") + " ")])]), _c('div', {
      staticClass: "meter_card_unit"
    }, [_vm._v("kW")])], 1), _c('div', {
      staticClass: "meter_card_divider"
    }), _c('div', {
      staticClass: "d-flex my-1"
    }, [_c('span', [_vm._v("即時需量")]), _c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('span', {
      key: _vm.lastUpdateTime,
      staticClass: "ml-auto"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$in2 = (_vm$meterData$lIdx8 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx8 === void 0 ? void 0 : _vm$meterData$lIdx8.instant_demand) !== null && _vm$meterData$lIdx$in2 !== void 0 ? _vm$meterData$lIdx$in2 : "-") + " ")])]), _c('span', [_vm._v(" 瓩")])], 1), _c('div', {
      staticClass: "d-flex my-1"
    }, [_c('span', [_vm._v("最大需量")]), _c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('span', {
      key: _vm.lastUpdateTime,
      staticClass: "ml-auto"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$ma2 = (_vm$meterData$lIdx9 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx9 === void 0 ? void 0 : _vm$meterData$lIdx9.max_demand) !== null && _vm$meterData$lIdx$ma2 !== void 0 ? _vm$meterData$lIdx$ma2 : "-") + " ")])]), _c('span', [_vm._v(" 瓩")])], 1), _c('div', {
      staticClass: "d-flex my-1"
    }, [_c('span', [_vm._v("累積用電")]), _c('transition', {
      attrs: {
        "name": "dataNum-fade"
      }
    }, [_c('span', {
      key: _vm.lastUpdateTime,
      staticClass: "ml-auto"
    }, [_vm._v(" " + _vm._s((_vm$meterData$lIdx$kW2 = (_vm$meterData$lIdx10 = _vm.meterData[lIdx]) === null || _vm$meterData$lIdx10 === void 0 ? void 0 : _vm$meterData$lIdx10.kWh) !== null && _vm$meterData$lIdx$kW2 !== void 0 ? _vm$meterData$lIdx$kW2 : "-") + " ")])]), _c('span', [_vm._v(" 度")])], 1)]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm$meterNameArr2 = _vm.meterNameArr) === null || _vm$meterNameArr2 === void 0 ? void 0 : _vm$meterNameArr2.length) > _vm.SHOW_SWIPER_COUNT,
      expression: "meterNameArr?.length > SHOW_SWIPER_COUNT"
    }],
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _c('div', {
    staticClass: "chart_line_wrap"
  }, [_c('div', {
    staticClass: "z_2 ml-2 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "content_title mr-10"
  }, [_vm._v(" 用電歷史 ")]), _c('div', {
    staticClass: "btn_toggle_group mr-6"
  }, _vm._l(_vm.dateFormatItems, function (item) {
    return _c('button', {
      key: item.label,
      class: ['btn_toggle', {
        active: _vm.selectedDateFormat === item.value
      }],
      on: {
        "click": function click($event) {
          return _vm.handleChangeDateOrDateFormat('changeDateFormat', item.value);
        }
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0), _c('date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedDateFormat !== 'all',
      expression: "selectedDateFormat !== 'all'"
    }],
    staticClass: "mr-6",
    attrs: {
      "type": _vm.datepickerTypeList[_vm.selectedDateFormat],
      "format": _vm.selectedDateFormat,
      "placeholder": "請選擇區間",
      "disabled-date": _vm.disabledDate,
      "prefix-class": "xmx",
      "clearable": false,
      "open": _vm.datePickerOpen,
      "range": ""
    },
    on: {
      "update:open": function updateOpen($event) {
        _vm.datePickerOpen = $event;
      },
      "change": function change($event) {
        return _vm.handleChangeDateOrDateFormat('changeDate');
      },
      "pick": _vm.handlePick,
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn(_ref3) {
        var emit = _ref3.emit;
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "mr-auto px-2"
        }, [_vm._v(" " + _vm._s(_vm.datepickerTypeList[_vm.selectedDateFormat] === "date" ? "選擇日期區間 2 個月" : _vm.datepickerTypeList[_vm.selectedDateFormat] === "month" ? "選擇月份區間 10 個月" : "選擇年份區間 10 年") + " ")]), _c('button', {
          staticClass: "xmx-btn xmx-btn-text px-2 py-1 border",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              {
                emit([new Date(), new Date()]);
                _vm.datePickerOpen = false;
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.datepickerTypeList[_vm.selectedDateFormat] === "date" ? "今天" : _vm.datepickerTypeList[_vm.selectedDateFormat] === "month" ? "本月" : "今年") + " ")])])];
      }
    }]),
    model: {
      value: _vm.selectedDate,
      callback: function callback($$v) {
        _vm.selectedDate = $$v;
      },
      expression: "selectedDate"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lineColumnChartOptions.series.length && _vm.chartSummary.timeRange,
      expression: "lineColumnChartOptions.series.length && chartSummary.timeRange"
    }],
    staticClass: "chart_summary text-muted cursor-default"
  }, [_vm._v(" " + _vm._s(_vm.chartSummary.timeRange) + " 總計: " + _vm._s(_vm.chartSummary.total) + " kWh ")])], 1), _vm.lineColumnChartOptions.series.length ? _c('highcharts', {
    staticClass: "mt-5",
    attrs: {
      "id": "lineColumnChartId",
      "options": _vm.lineColumnChartOptions
    }
  }) : _c('div', {
    staticClass: "no_data d-flex align-items-center justify-content-center text-muted"
  }, [_vm._v(" 尚無資料 ")])], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };